module.exports = __webpack_public_path__ + "img/rtl-Creative-demo.b9456701.png";